import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import AppShell from './AppShell';

// Catches render-time errors so one bad catalog entry (or any component
// throw) shows a recoverable message instead of white-screening the app.
// Keyed by route in App so navigating away clears the error.
interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[web] render error:', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <AppShell>
          <div className="empty-state">
            <h2>Something went wrong</h2>
            <p className="error">{this.state.error.message}</p>
            <p>
              <a className="btn btn-secondary" href="/">
                Back to trips
              </a>
            </p>
          </div>
        </AppShell>
      );
    }
    return this.props.children;
  }
}
